import { ComponentProps, FC } from "react";
import { useTranslation } from "react-i18next";

import { DeleteConfirmModal, Modal } from "@/sx-layout/common/Modal";

type Props = ComponentProps<typeof Modal> & {
  onSubmit?: () => void;
};

export const DeleteClipAreaModal: FC<Props> = ({ onClose, onSubmit }) => {
  const { t } = useTranslation();

  return <DeleteConfirmModal message={t("remove_area_detail_sure")} onClose={onClose} onSubmit={onSubmit} />;
};
